import { IAuditLog } from 'global/interfaces/IAuditLog';
import { authorizedGet } from './baseApiService';

const baseUrl = 'audit';

export async function getUserAuditLog(userId: string): Promise<IAuditLog[]> {
  return await authorizedGet<IAuditLog[]>(`${baseUrl}?userId=${userId}`);
}
